import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-approvance-form',
  templateUrl: './approvance-form.component.html',
  styleUrls: ['./approvance-form.component.css']
})
export class ApprovanceFormComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/finance/approvance/approvance-form/approvance-form.component.ts